var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.num!=null)?[_c('div',{attrs:{"id":"elect"}},[_c('div',{style:({
          width: _vm.num + '%',
          background: _vm.num <= 20 ? 'red' : '#0ab927',
        }),attrs:{"id":"enow"}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.num == null ? 0 : _vm.num)+"%")])]:[_vm._v("\n     暂无电量数据\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a366423","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/locate/com/elect.vue
// module id = null
// module chunks = 